<template>
  <FormGroupBox title="API Keys Management" appendExtra>
    <template #append-title>
      <b-button
        class="ml-2"
        size="sm"
        variant="success"
        @click="openCreateModal"
      >
        <md-icon icon="add" />
        Create API Key
      </b-button>
    </template>

    <div class="api-keys-management">
      <b-alert show variant="info" class="mb-3">
        <md-icon icon="info" class="mr-1" />
        <strong>API Keys</strong> allow programmatic access to ShuttleCentral services.
        Keep your keys secure and never share them publicly.
      </b-alert>

      <ApiKeysList
        ref="apiKeysList"
        :supplierId="supplierId"
        @edit="openEditModal"
        @regenerated="onKeyRegenerated"
        @show-key="onShowKey"
      />

      <!-- Modals -->
      <CreateApiKeyModal
        ref="createModal"
        :supplierId="supplierId"
        @created="onKeyCreated"
      />

      <EditApiKeyModal
        ref="editModal"
        @updated="onKeyUpdated"
      />

      <KeySecurityModal
        ref="securityModal"
      />
    </div>
  </FormGroupBox>
</template>

<script>
import FormGroupBox from '@/components/helpers/FormGroupBox';
import ApiKeysList from './ApiKeysList.vue';
import CreateApiKeyModal from './CreateApiKeyModal.vue';
import EditApiKeyModal from './EditApiKeyModal.vue';
import KeySecurityModal from './KeySecurityModal.vue';

export default {
  name: 'ApiKeysManagement',
  components: {
    FormGroupBox,
    ApiKeysList,
    CreateApiKeyModal,
    EditApiKeyModal,
    KeySecurityModal
  },
  props: {
    supplierId: {
      type: [Number, String],
      required: true
    }
  },
  methods: {
    openCreateModal() {
      this.$refs.createModal.show();
    },
    openEditModal(apiKey) {
      this.$refs.editModal.show(apiKey);
    },
    onKeyCreated(response) {
      // Show the security modal with the new key
      if (response.key) {
        this.$refs.securityModal.show(response.key);
      }

      // Refresh the list
      this.$refs.apiKeysList.loadApiKeys();
    },
    onKeyUpdated() {
      // Refresh the list
      this.$refs.apiKeysList.loadApiKeys();
    },
    onKeyRegenerated(response) {
      // Show the security modal with the new key
      if (response.key) {
        this.$refs.securityModal.show(response.key);
      }
    },
    onShowKey(key) {
      // Show the security modal with the existing key
      this.$refs.securityModal.show(key);
    }
  }
};
</script>

<style scoped>
.api-keys-management {
  padding: 0.5rem 0;
}
</style>
